import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
// TODO: Legacy file - needs full refactor to use categories instead of divisions/seasons
import {
  // createDivision,
  // selectDivision,
  // selectSeason,
  updateTournament,
} from "../../redux/slices/tournamentSlice";
import { fixedValues } from "../../utils/fixedValues";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import { tournamentWizardStepCompleted } from "../../utils/analytics";
import { WIZARD_STEP } from "../../utils/analyticsEvents";
import "./ChooseTournament.css";

const ChooseTournament = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const [selectedType, setSelectedType] = useState(
    selectedTournament?.type || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedTournament?.type) {
      setSelectedType(selectedTournament.type);
    }
  }, [selectedTournament]);

  const handleNext = async () => {
    try {
      if (!selectedType) {
        toast.error("Please select a tournament type");
        return;
      }

      setIsLoading(true);

      // Update the tournament type
      const result = await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData: { type: selectedType },
        })
      ).unwrap();

      if (result) {
        // TODO: Legacy - createDivision, selectDivision, selectSeason removed
        // const defaultDivision = {
        //   name: fixedValues.defaultTournamentDetails.division.name,
        //   isSelected: true,
        //   numberOfTeams: 0,
        //   season: [
        //     {
        //       name: fixedValues.defaultTournamentDetails.division.season.name,
        //       isSelected: true,
        //       registrationFee: 0,
        //     },
        //   ],
        // };
        //
        // const divisionResult = await dispatch(
        //   createDivision({
        //     tournamentId: selectedTournament.id,
        //     divisionData: defaultDivision,
        //   })
        // ).unwrap();
        //
        // if (divisionResult) {
        //   const defaultDivision = divisionResult.divisions[0];
        //   if (defaultDivision) {
        //     dispatch(selectDivision(defaultDivision));
        //
        //     const defaultSeason = defaultDivision.season[0];
        //     if (defaultSeason) {
        //       dispatch(selectSeason(defaultSeason));
        //     }
        //   }
        // }

        tournamentWizardStepCompleted({
          stepName: WIZARD_STEP.CHOOSE_TOURNAMENT,
          tournamentId: selectedTournament?.id,
        });
        toast.success("Tournament type updated successfully!");
        navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CHOOSE_DURATION_TYPE);
      } else {
        throw new Error("Failed to update tournament type");
      }
    } catch (error) {
      toast.error(error.message || "Failed to update tournament type");
    } finally {
      setIsLoading(false);
    }
  };

  const tournaments = [
    {
      id: fixedValues.tournamentTypes.LEAGUE,
      name: fixedValues.tournamentTypes.LEAGUE,
    },
    {
      id: fixedValues.tournamentTypes.GROUP,
      name: fixedValues.tournamentTypes.GROUP,
    },
    {
      id: fixedValues.tournamentTypes.KNOCKOUT,
      name: fixedValues.tournamentTypes.KNOCKOUT,
    },
  ];

  return (
    <>
      <div className="input-section">
        <p>Pick Your Competition Format</p>
        <div className="tournaments-container">
          {tournaments.map((tournament) => (
            <button
              key={tournament.id}
              className={`tournament-option ${
                selectedType === tournament.id ? "selected" : ""
              }`}
              onClick={() => setSelectedType(tournament.id)}
              type="button"
            >
              <div className="tournament-radio" />
              <span className="tournament-name">{tournament.name}</span>
            </button>
          ))}
        </div>
      </div>

      <ClubbieButton
        className="next-button"
        onClick={handleNext}
        disabled={isLoading || !selectedType}
        isLoading={isLoading}
      >
        Next
      </ClubbieButton>
    </>
  );
};

export default ChooseTournament;
